<template>
  <b-form-group
    :name="name"
    :label="label"
    :input-cols="inputCols"
  >
    <template slot-scope="{ attrs, listeners }">
      <b-input-group v-if="inputGroup">
        <template #prepend>
          <b-input-group-text id="info"><img src="@/assets/info.png"></b-input-group-text>
        </template>
        <b-form-input
          v-if="!select"
          :class="alignRight ? 'alignR' : 'alignL'"
          :disabled="disabled"
          size="sm"
          :placeholder="placeholder"
          v-bind="attrs"
          v-model.trim="m[name]"
          @input="alignRight ? (m[name] = m[name].toString().replace(',', '.')) : null"
          v-on="listeners"
        />
      </b-input-group>

      <b-form-input
        v-if="!select && !inputGroup"
        :class="alignRight ? 'alignR' : 'alignL'"
        :disabled="disabled"
        size="sm"
        :placeholder="placeholder"
        v-bind="attrs"
        v-model.trim="m[name]"
        @input="alignRight ? (m[name] = m[name].toString().replace(',', '.')) : null"
        v-on="listeners"
      />
      <b-form-text v-if="hint !== null">{{ hint }}</b-form-text>
      <b-form-select
        v-if="select"
        v-bind="attrs"
        v-model.trim="m[name]"
        :options="options"
        v-on="listeners"
      />
    </template>
  </b-form-group>
</template>

<script>
import bFormGroup from '@/components/FormGroup.vue'

export default {
  components: {
    bFormGroup,
  },
  props: {
    label: {
      type: String,
      default: null,
      required: false
    },
    m: {
      type: Object,
      attribute: Object,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    inputCols: {
      type: Number,
      default: 6
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: null
    },
    hint: {
      type: String,
      default: null
    },
    alignRight: {
      type: Boolean,
      default: true,
      required: false
    },
    select: {
      type: Boolean,
      default: false,
      required: false
    },
    options: {
      type: Array,
      default: null,
      required: false
    },
    inputGroup: {
      type: Boolean,
      default: false
    }
  },
};
</script>
<style>
.text-muted {
  font-size: 0.8em;
}
</style>
